import { createTV, cx as join } from "tailwind-variants";

/** The one way to declare component variants. Class merging is off on purpose: tailwind-merge does not know our
 *  token utilities (text-md, text-fg-muted) and would drop one of them. Never pass conflicting classes. */
export const tv = createTV({ twMerge: false });
/** Join class names; always a string (React Aria render props require one). */
export const cx = (...parts: Parameters<typeof join>): string => join(...parts) ?? "";
export type { VariantProps } from "tailwind-variants";

/** Join a React Aria render-prop className with extra classes. */
export function composeCls<T>(base: string | ((v: T) => string), extra?: string | ((v: T) => string)) {
  return (v: T) => cx(typeof base === "function" ? base(v) : base, typeof extra === "function" ? extra(v) : extra);
}
